import { render, staticRenderFns } from "./PromoPopup.vue?vue&type=template&id=073a58f5&scoped=true"
import script from "./PromoPopup.vue?vue&type=script&lang=js"
export * from "./PromoPopup.vue?vue&type=script&lang=js"
import style0 from "./PromoPopup.vue?vue&type=style&index=0&id=073a58f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a58f5",
  null
  
)

export default component.exports